import { useState } from 'react';
import { useGmailQueued, useAssignGmailMessage, useDismissGmailMessage } from '../../hooks/queries/useGmailInbox';
import { GmailMessageCard } from './GmailMessageCard';

export function GmailInboxToTriageTab() {
  const { data: queued, isLoading } = useGmailQueued();
  const assignMut = useAssignGmailMessage();
  const dismissMut = useDismissGmailMessage();
  const [selectedDossier, setSelectedDossier] = useState<Record<string, string>>({});

  if (isLoading) return <div className="p-4 text-gray-500">Chargement…</div>;
  if (!queued || queued.length === 0) {
    return (
      <div className="p-8 text-center text-gray-500">
        <div className="text-2xl mb-2">🎉</div>
        Aucun mail à trier.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {queued.map((m) => (
        <GmailMessageCard
          key={m.id!}
          fromName={m.from_name}
          fromEmail={m.from_email!}
          subject={m.subject}
          internalDate={m.internal_date!}
          badge={
            <div className="text-xs text-gray-600">
              {(m.candidate_dossier_ids ?? []).length} dossiers candidats
            </div>
          }
          actions={
            <div className="flex flex-col gap-2">
              <select
                value={selectedDossier[m.id!] ?? ''}
                onChange={(e) => setSelectedDossier({ ...selectedDossier, [m.id!]: e.target.value })}
                className="text-sm border rounded px-2 py-1"
              >
                <option value="">— Choisir un dossier —</option>
                {(m.candidate_dossier_ids ?? []).map((id) => (
                  <option key={id} value={id}>{id.slice(0, 8)}…</option>
                ))}
              </select>
              <div className="flex gap-2">
                <button
                  disabled={!selectedDossier[m.id!] || assignMut.isPending}
                  onClick={() => assignMut.mutate({ id: m.id!, dossierId: selectedDossier[m.id!]! })}
                  className="px-3 py-1.5 bg-cime-primary text-white text-sm rounded hover:opacity-90 disabled:opacity-50"
                >
                  Rattacher
                </button>
                <button
                  disabled={dismissMut.isPending}
                  onClick={() => dismissMut.mutate({ id: m.id!, reason: 'manual_dismiss' })}
                  className="px-3 py-1.5 border text-sm rounded hover:bg-gray-50"
                >
                  Ignorer
                </button>
              </div>
            </div>
          }
        />
      ))}
    </div>
  );
}
